(function () {
  if (window.__heroEntranceInit) return;
  window.__heroEntranceInit = true;

  function init() {
    document.querySelectorAll('.hero[data-entrance-animation]').forEach(function (hero) {
      if (hero.dataset.entranceAnimation === 'none' || hero.classList.contains('hero--visible')) {
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              hero.classList.add('hero--visible');
              observer.unobserve(hero);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
